import React from 'react';

import styled from 'styled-components';

import { Heading, colors, spacing } from '@sine/sine-ui-components';

const HeadingWrapperStyles = styled.div`
  background: ${colors.grey200};
  padding: ${spacing(0.5)} ${spacing(1.5)};
  border-radius: ${spacing(0.5)};
`;

interface SubtitleProps {
  className?: string;
  children: React.ReactNode;
}

export default function Subtitle({ className, children }: SubtitleProps) {
  return (
    <HeadingWrapperStyles className={className}>
      <Heading type='h5'>{children}</Heading>
    </HeadingWrapperStyles>
  );
}
